var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-coverage-report-chart"},[(_vm.chartData.length === 0)?_c('div',{staticClass:"no-data"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('noExistingBuildings'))+" ")])]):_c('PieChart',{attrs:{"chart-data":_vm.processedChartData,"options":_vm.options,"grouping-name":_vm.$t(`groupByKeys.dataquality`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }